import { pdfOptions } from 'ComponentLibrary/src/common/pdf'
import { Dialog, DialogActions, DialogContent, DialogTitle, Link, Pagination, Stack, useTheme } from '@mui/material'
import { useState } from 'react'
import { Document, Page } from 'react-pdf'
import 'react-pdf/dist/Page/TextLayer.css'
import 'react-pdf/dist/Page/AnnotationLayer.css'
import { Download, X } from 'react-feather'
import { IconButton } from 'ComponentLibrary/src/atoms/Buttons/IconButton'
import { Button } from '../../atoms/Buttons/Button'
import { isObject } from 'lodash'
import { LoadingSkeleton } from '../../atoms/LoadingSkeleton'
import Typography from 'ComponentLibrary/src/atoms/typography/Typography'

interface PDFViewerType {
    file?: Blob | string
    open?: boolean
    setOpen?: (open: boolean) => void
    fileName: string
    downloadLabel?: string
    pageNumber: number
    setPageNumber: (pageNumber: number) => void
}

export function PDFViewer({ file, open = false, setOpen, fileName, downloadLabel = 'Download', pageNumber, setPageNumber }: PDFViewerType) {
    const theme = useTheme()
    const [numPages, setNumPages] = useState<number | null>(null)

    function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
        setNumPages(numPages)
    }

    return (
        <Dialog fullWidth={false} maxWidth="xl" open={open} onClose={() => setOpen?.(false)}>
            <DialogTitle>
                <Stack direction="row" justifyContent="space-between" width="100%" marginY={theme.spacing(1)}>
                    <Typography variant="headline1">{fileName}</Typography>
                    {setOpen && <IconButton icon={<X color={theme.palette.customtext.black54} />} onClick={() => setOpen(false)} />}
                </Stack>
            </DialogTitle>
            <DialogContent sx={{ py: 0, border: `1px solid ${theme.palette.secondary1.grey}` }}>
                <Document
                    options={pdfOptions}
                    file={file}
                    onLoadSuccess={onDocumentLoadSuccess}
                    loading={<LoadingSkeleton height="655px" width="545px" sx={{ transform: 'none', marginY: '24px' }} />}
                >
                    <Page pageNumber={pageNumber} scale={1.25} />
                </Document>
            </DialogContent>
            <DialogActions>
                <Stack direction="row" justifyContent="space-between" width="100%" padding={theme.spacing(1)}>
                    <Link target="_blank" href={isObject(file) ? URL.createObjectURL(file) : file}>
                        <Button size="small" variant="secondary" startIcon={<Download />} label={downloadLabel} />
                    </Link>
                    {numPages && numPages > 1 && (
                        <Pagination
                            page={pageNumber}
                            onChange={(_e, value) => {
                                setPageNumber(value)
                            }}
                            count={numPages}
                            size="small"
                        />
                    )}
                </Stack>
            </DialogActions>
        </Dialog>
    )
}
